var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StepDetailsHeader',_vm._b({attrs:{"showDropdownMenu":false},scopedSlots:_vm._u([{key:"name-input",fn:function(){return [_c('div',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.title))])]},proxy:true}])},'StepDetailsHeader',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }